import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_end.jpg';
// page.games = [
//   // {
//   //   id: 'page999_game997',
//   //   tooltip: '',
//   //   icon: 'ikonaStepbystep',
//   //   pos: {
//   //     x: RIGHT,
//   //     y: 68,
//   //   },
//   // },
//   // {
//   //   id: 'page999_game996',
//   //   tooltip: '',
//   //   icon: 'ikonaStepbystep',
//   //   pos: {
//   //     x: RIGHT,
//   //     y: 200,
//   //   },
//   // },
//   {
//     id: 'page001_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2200,
//     },
//   },
//   {
//     id: 'page001_game2',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2050,
//     },
//   },
//   {
//     id: 'page001_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1900,
//     },
//   },
//   {
//     id: 'page002_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1750,
//     },
//   },
//   {
//     id: 'page002_game2',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1600,
//     },
//   },
//   {
//     id: 'page002_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1450,
//     },
//   },
//   // {
//   //   id: 'page001_game5',
//   //   tooltip: '',
//   //   icon: 'ikonaStepbystep',
//   //   pos: {
//   //     x: RIGHT,
//   //     y: 1300,
//   //   },
//   // },
//   {
//     id: 'page003_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1300,
//     },
//   },
//   {
//     id: 'page003_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1150,
//     },
//   },
//   {
//     id: 'page004_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1000,
//     },
//   },
//   {
//     id: 'page006_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 850,
//     },
//   },
//   {
//     id: 'page006_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 700,
//     },
//   },
//   {
//     id: 'page007_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 550,
//     },
//   },
//   {
//     id: 'page010_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 400,
//     },
//   },
//   {
//     id: 'page011_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 250,
//     },
//   },
//   {
//     id: 'page012_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 100,
//     },
//   },
//   {
//     id: 'page013_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 0,
//     },
//   },
// ];
export default page;
